import { typedQueryClient, useTypedMutation } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInService } from "models";

export const useUpdateCheckInServiceMutation = () =>
  useTypedMutation<CheckInService, void>({
    mutationFn: payload => ApiInstance.post("/check_in/service/update", payload),
    onSuccess: updatedService => {
      const dealerServices = typedQueryClient.getQueryData(CheckInServicesQueryKeys.dealerList);
      const dealerServiceIdx = dealerServices?.findIndex(service => service.id === updatedService.id) ?? -1;
      if (dealerServices && dealerServiceIdx > -1)
        typedQueryClient.setQueryData(CheckInServicesQueryKeys.dealerList, dealerServices.with(dealerServiceIdx, updatedService));

      const locationServices = typedQueryClient.getQueryData(CheckInServicesQueryKeys.locationList);
      const locationServiceIdx = locationServices?.findIndex(service => service.id === updatedService.id) ?? -1;
      if (locationServices && locationServiceIdx > -1)
        typedQueryClient.setQueryData(CheckInServicesQueryKeys.locationList, locationServices.with(locationServiceIdx, updatedService));
    }
  });
